/** "Salesforce ↗" to a client's Account in Manheim's Salesforce, and the rep-name tag beside it.
 *  Used on the Client View and Sales View cards, the Inspection Call List and Plan My Week. */
import React from 'react';
import './SalesforceLink.css';

const salesforceAccountUrl = (salesforceId: string): string =>
  `https://manheim.lightning.force.com/lightning/r/Account/${encodeURIComponent(salesforceId)}/view`;

interface SalesforceLinkProps {
  salesforceId?: string | null;
  className?: string;
}

/** Renders nothing without an id. Never opens the card it sits on. */
export const SalesforceLink: React.FC<SalesforceLinkProps> = ({ salesforceId, className }) => {
  if (!salesforceId) return null;
  return (
    <a
      className={`sf-link${className ? ` ${className}` : ''}`}
      href={salesforceAccountUrl(salesforceId)}
      target="_blank"
      rel="noopener noreferrer"
      title="Open client profile in Salesforce"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      Salesforce ↗
    </a>
  );
};

interface RepTagProps {
  name?: string | null;
  /** Which rep it is, for the tooltip: "CSE rep" or "RDS rep". */
  role: string;
}

export const RepTag: React.FC<RepTagProps> = ({ name, role }) => {
  const text = (name ?? '').trim();
  if (!text) return null;
  return (
    <span className="rep-tag" title={`${role}: ${text}`}>
      {text}
    </span>
  );
};
